import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import Select from "../components/FixedRequiredSelect";

function valueOf(v) {
  if (!v) return "";
  if (typeof v === "object") return v.value;
  return v;
}

export default class MultiSelectField extends PureComponent {
  handleChange = (value, _actionMeta) => {
    const { name, maxItems, onChange } = this.props;
    const length = value ? value.length : 0;
    if (maxItems && length > maxItems) {
      onChange(name, value.slice(0, maxItems));
      // TODO: show error message if we have more ?
    } else {
      onChange(name, value);
    }
  };

  /**
   * Convert string[] to object[]
   */
  expandValues = values => {
    if (!values) return values;
    const { options = [] } = this.props;
    return values
      .map(valueOf)
      .map(v => options.find(o => o.value === v))
      .filter(v => v);
  };

  render() {
    const { name, label, value, options = [], placeholder, required, disabled, searchable = true } = this.props;
    return (
      <FieldContainer {...this.props}>
        <div className="af-multi-select-container">
          <Select
            value={this.expandValues(value)}
            required={required}
            placeholder={placeholder || label}
            onChange={this.handleChange}
            options={options}
            isMulti={true}
            isSearchable={searchable}
            isDisabled={disabled}
          />
          {/* Inject values in HTML POST as {name}[] to create a JSON array */}
          {value &&
            value.map(v => (
              <input key={valueOf(v)} name={name + "[]"} value={valueOf(v)} readOnly style={{ display: "none" }} />
            ))}
        </div>
      </FieldContainer>
    );
  }
}
